module.exports = __webpack_public_path__ + "img/9788937818639.6e0b1edc.jpg";